module.exports = __webpack_public_path__ + "img/delete-cropper.361ad564.svg";